import React, { useState } from 'react'
import { Accordion, Button, Col, Collapse, Row } from 'react-bootstrap'
import { ICompany } from '../models/Company'

type CompanyBoxProps = {
  company: ICompany
}
export const CompanyBox: React.FC<CompanyBoxProps> = (props: CompanyBoxProps) => {
  const { company } = props
  const [open, setOpen] = useState(true)
  return (
    <>
      <h3
        onClick={() => setOpen(!open)}
        aria-controls='company-collapse'
        aria-expanded={open}
        className='card-title align-items-start flex-column w-100 text-hover-primary mt-2 mb-8'
      >
        {open ? (
          <i className='bi bi-chevron-up text-hover-primary mx-2 fw-boldest'></i>
        ) : (
          <i className='bi bi-chevron-down text-hover-primary mx-2 fw-boldest'></i>
        )}
        {company.name}
      </h3>
      <Collapse in={open}>
        <div id='company-collapse' className='p-5'>
          <Row>
            <Col md={6}>
              {[
                {
                  label: 'Name',
                  value: company.name,
                },
                {
                  label: 'Website',
                  value: company.website,
                },
                {
                  label: 'Street Address',
                  value: company.streetAddress,
                },
                {
                  label: 'Street Address 2',
                  value: company.streetAddressTwo,
                },
                {
                  label: 'City',
                  value: company.city,
                },
                {
                  label: 'State',
                  value: company.state,
                },
                {
                  label: 'Country',
                  value: company.country,
                },
              ].map((item, index) => (
                <div key={index} className='d-flex mb-3 me-15'>
                  <span className='flex-grow-2 text-muted min-w-150px'>{item.label}</span>
                  <span className='flex-grow-1 fw-bold'>{item.value}</span>
                </div>
              ))}
            </Col>
            <Col md={6}>
              {[
                {
                  label: 'Phone',
                  value: company.phone,
                },
                {
                  label: 'LinkedIn',
                  value: company.linkedin,
                },
                {
                  label: 'Employee Range',
                  value: company.employeeRange?.name,
                },
                {
                  label: 'Revenue Range',
                  value: company.revenueRange?.name,
                },
                {
                  label: 'Primary Industry',
                  value: company.primaryIndustry?.name,
                },
                {
                  label: 'Secondary Industry',
                  value: company.secondaryIndustry?.name,
                },
              ].map((item, index) => (
                <div key={index} className='d-flex mb-3 me-10'>
                  <span className='flex-grow-2 text-muted min-w-150px'>{item.label}</span>
                  <span className='flex-grow-1 fw-bold'>{item.value}</span>
                </div>
              ))}
            </Col>
          </Row>
        </div>
      </Collapse>
    </>
  )
}
